// Single source of truth for the app version shown in diagnostic contexts
// (currently: the support form's "Sent automatically" card). Keep this in
// sync with package.json's "version" field by hand — CRA's ModuleScopePlugin
// blocks importing package.json itself from inside src/.
export const APP_VERSION = '0.1.0';
